import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useTranslation } from "react-i18next";

export default function DeleteDialog({ open, handleClose, day, title }) {
  const { t } = useTranslation();
  const [value, setValue] = React.useState("delete_this");
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleCancel = () => {
    handleClose({ type: "cancel" });
  };

  const handleOk = () => {
    handleClose({ type: value });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("common.buttons.remove")}
        </DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="delte options"
              name="delete"
              value={value}
              onChange={handleChange}
            >
              <FormControlLabel
                value="delete_this"
                control={<Radio color="primary" />}
                label={t("scheduler.deleteDialog.this")}
              />
              <FormControlLabel
                value="delete_day"
                control={<Radio color="primary" />}
                label={t("scheduler.deleteDialog.on", { title, day })}
              />
              <FormControlLabel
                value="delete_all"
                control={<Radio color="primary" />}
                label={t("scheduler.deleteDialog.all", { title })}
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>
            {t("common.actions.cancel")}
          </Button>
          <Button onClick={handleOk} color="primary" autoFocus>
            {t("common.actions.ok")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
